import {
    CONFIRMED_GET_FREQUENCIES,
    CONFIRMED_CREATE_FREQUENCY,
    CONFIRMED_DELETE_FREQUENCY,
    CONFIRMED_EDIT_FREQUENCY,
  } from "../types/FrequencyTypes";
  
  const initialState = {
    list: [],
    num_rows: 0,
  };
  
  export default function FrequencyReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_FREQUENCIES:
        return {
          ...state,
          list: action.payload.list,
          num_rows: action.payload.num_rows,
        };
  
      case CONFIRMED_CREATE_FREQUENCY:
        return {
          ...state,
          list: [...state.list, action.payload],
        };
  
      case CONFIRMED_DELETE_FREQUENCY:
        return {
          ...state,
          list: state.list.filter(
            (item) =>
              item.frequency_id !== action.payload.frequency_id
          ),
        };
  
      case CONFIRMED_EDIT_FREQUENCY:
        const updatedList = [...state.list];
        const index = updatedList.findIndex(
          (item) =>
            item.frequency_id === action.payload.frequency_id
        );
  
        if (index !== -1) {
          updatedList[index] = action.payload;
        }
  
        return {
          ...state,
          list: updatedList,
        };
  
      default:
        return state;
    }
  }
  